<app-card>
  <app-card-header
    iconPath="assets/icons/calendar-dots.svg"
    [title]="'Trainingstermine'"
    [showLoadingSpinner]="requestState() === RequestStateEnum.PENDING"
  />

  <app-paginator
    [intervalType]="paginatorIntervalTypeEnum.WEEK"
    (paginationChange)="onPaginatorChange($event.index, $event.year)"
  />

  <div
    class="flex flex-col leading-4 border-light-grey"
    [class.border-b]="activities().length > 0"
  >
    @if (activities().length === 0) {
      <app-no-entries-placeholder text="Keine Aktivitäten verfügbar" />
    }

    @for (activity of activities(); track activity.id) {
      <app-activity-item [activity]="activity" />
    }
  </div>
</app-card>
